var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesDropdownIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5461)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76686 1.38184H16.33C17.4256 1.38184 18.3137 2.26995 18.3137 3.36549V15.9286C18.3137 17.0242 17.4256 17.9123 16.33 17.9123H3.76686C2.67132 17.9123 1.7832 17.0242 1.7832 15.9286V3.36549C1.7832 2.26995 2.67132 1.38184 3.76686 1.38184Z",
    stroke: "#003A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45654 9.24273L9.23802 12.8616L14.6401 6.43311",
    stroke: "#003A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3672,
    height: 18.3672,
    fill: "white",
    transform: "translate(0.867188 0.464844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesDropdownIcon3);
export default __webpack_public_path__ + "static/media/resources-dropdown-icon-3.bede343c22920bd4354571756fcd8879.svg";
export { ForwardRef as ReactComponent };